const INCHES_PER_METER = 39.3701;

export function convertMetersToInchesForDisplay(
  meters: number,
  roundTo = 1,
): number {
  const value = meters * INCHES_PER_METER;
  const multiplier = Math.pow(10, roundTo);
  return Math.round(value * multiplier) / multiplier;
}

export function convertMetersToFeetAndInchesForDisplay(
  meters: number,
): [number, number] {
  const inches = meters * INCHES_PER_METER;
  return [Math.floor(inches / 12), Math.round(inches % 12)];
}
